
import { ENDPOINTS } from "../../apiConfig";
import { showToast } from "../../../components";
import axiosRequest from "../universal/axiosService";

export const fetchImmigration = async (params) => {
  const filter = {
    uiid: {
      type: "NONE",
      value: params.uiid,
    },
  };
  return await axiosRequest({
    method: 'GET',
    url: ENDPOINTS.IMMIGRATION.GET_BY_UIID,
    params: {
      coll: params.coll,
      fil: JSON.stringify(filter),
      ret: params.ret,
      ref: params.ref,
    },
  });
};

export const addNewImmigration = async (placementData, coll, tPath) => {
 const url=coll==="LCA"?ENDPOINTS.LCA.ADD_NEW:coll==="H1B"?ENDPOINTS.H1B.ADD_NEW:coll==="Visa"?ENDPOINTS.VISA.ADD_NEW:coll==="JobNAdv"?ENDPOINTS.JOBNADVS.ADD_NEW: "";
  return await axiosRequest({
    method: 'POST',
    url: url,
    data: {
      coll,
      ...(tPath && { tPath }),
      payload: placementData,
    },
  });
};

export const updateImmigration = async (uiid, patchId, coll, payload, tPath) => {
  const queryParams = new URLSearchParams({
    coll,
    uiid,
    ...(patchId && { patchId }),
    ...(tPath && { tPath }),
  });
const url=coll==="LCA"?ENDPOINTS.LCA.UPDATE:coll==="H1B"?ENDPOINTS.H1B.UPDATE:coll==="Visa"?ENDPOINTS.VISA.UPDATE:coll==="JobNAdv"?ENDPOINTS.JOBNADVS.UPDATE: "";
  return await axiosRequest({
    method: 'PATCH',
    url: `${url}?${queryParams.toString()}`,
    data: { payload },
  });
};
export const fetchAllImmigrations= async (params) => {
  const url=params?.coll==="LCA"?ENDPOINTS.LCA.GET_ALL:params?.coll==="H1B"?ENDPOINTS.H1B.GET_ALL:params?.coll==="Visa"?ENDPOINTS.VISA.GET_ALL:params?.coll==="JobNAdv"?ENDPOINTS.JOBNADVS.GET_ALL:  ENDPOINTS.LCA.GET_BY_UIID;
  return await axiosRequest({
    method: 'GET',
    url:url,
    params: {
      coll: params.coll,
      fil: JSON.stringify(params?.filter),
      ret: params.ret,
      ref: params.ref,
      lim: params.limit,
      pg: params.page,
      incl: params.incl,
    },
  });
}